exports = module.exports = require("../../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".lt-modal-error__body{color:#0b2318;text-align:center}.lt-modal-error__title{display:block;margin-bottom:8px;font-size:18px;line-height:1.3}.lt-modal-error__message,.lt-modal-error__guidance,.lt-modal-error__order{margin:0 0 8px;font-size:14px;line-height:1.45}.error-popup-block .lb-content button.bt{display:block;float:none;margin:0 auto;border:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/components/UI/Modal/modalError.scss
// module id = 674
// module chunks = 7